import React, { useState } from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { Close } from "@material-ui/icons";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Slide,
} from "@material-ui/core";
import { CyNumber } from "../../../../utilities/number";
import CurrencyNumber from "../../../../components/UI/CurrencyNumber";

const styles = (theme) => ({
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  paramBlock: {
    fontSize: 16,
    lineHeight: 1.5,
    '& > div': {
      marginBottom: 16,
    }
  },
  paramLabel: {
    textAlign: "right",
    borderRight: `1px solid ${theme.palette.grey["A400"]}`,
    paddingRight: 16,
  },
  paramValue: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    marginLeft: 16,
  },
  paramInput: {
    "& .MuiInputBase-root.MuiInputBase-formControl": {
      marginTop: 0,
    },
  },
});

const PortfolioFeeUpdateModal = ({
  classes,
  open,
  handleCloseModal,
  initialInvestment,
  onSave,
  managerType,
  strategyMin,
}) => {
  const { CurrencyFormatter, CurrencyParser } = CyNumber;
  const [amount, setAmount] = useState(initialInvestment);
  const [validationResult, setValidationResult] = useState({
    status: true,
    message: "",
  });

  function validateAmount(value) {
    if (value.toString().trim() === "") {
      return {
        status: false,
        message: "Please fill the field",
      };
    }
    let initialInvestment = CyNumber.CurrencyParser(value);
    if (strategyMin) {
      const isOverThreshold = initialInvestment >= Number(strategyMin);
      if (isOverThreshold) {
        return {
          status: isOverThreshold,
          message: "",
        };
      } else {
        return {
          status: false,
          message: `The minimum is $${Number(strategyMin)}`,
        };
      }
    }
    if (
      initialInvestment < 250000 &&
      (managerType === "WBI Blend" ||
        managerType === "WBI Blend 10 Year")
    ) {
      return {
        status: false,
        message: "The minimum is $250,000",
      };
    } else if (
      initialInvestment < 100000 &&
      managerType === "WBI Portfolios"
    ) {
      return {
        status: false,
        message: "The minimum is $100,000",
      };
    } else if (initialInvestment < 10000) {
      return {
        status: false,
        message: "The minimum is $10,000",
      };
    } else {
      return {
        status: true,
        message: "",
      };
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setAmount(CurrencyParser(value));
    setValidationResult(validateAmount(value));
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Slide}
      TransitionProps={{ direction: "up" }}
      onClose={handleCloseModal}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      maxWidth={"lg"}
      scroll={"paper"}
      classes={{ paper: classes.paper }}
      aria-labelledby="portfolio-fee-update-modal-title"
      aria-describedby="portfolio-fee-update-modal-description"
    >
      <DialogTitle id="household-settings-modal-title" disableTypography>
        <Typography variant="h5">
          <strong>Confirm Portfolio Value</strong>
        </Typography>
        <IconButton
          className={classes.modalCloseBtn}
          aria-label="Close"
          onClick={handleCloseModal}
        >
          <Close color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container className={classes.paramBlock}>
          <Grid item xs={6}>
            <div className={classes.paramLabel}>
              Household Assets Available :
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.paramValue}>
              <CurrencyNumber value={initialInvestment} />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.paramLabel}>
              Investment Amount :
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.paramValue}>
              <TextField
                required
                value={CurrencyFormatter(amount)}
                error={!validationResult.status}
                helperText={validationResult.status ? "" : validationResult.message}
                onChange={handleAmountChange}
                inputRef={(el) => (this.input = el)}
                className={classes.paramInput}
              />
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={onSave(amount)}
          disabled={!validationResult.status}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PortfolioFeeUpdateModal.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  initialInvestment: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  managerType: PropTypes.string.isRequired,
  strategyMin: PropTypes.string.isRequired,
};

export default withStyles(styles)(PortfolioFeeUpdateModal);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/PortfolioFeeUpdateModal/index.jsx